import React from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  useDisclosure,
} from '@chakra-ui/react';
import { FiMenu} from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { useAuth } from "../Context/AdminAuthContext";
import { useNavigate } from "react-router-dom";


function Dashboard() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("loginCheck");
    localStorage.removeItem("token");
    localStorage.removeItem("uid");
    localStorage.removeItem("loginsetName");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("username");
    document.cookie = "username=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    navigate("/");
  };
  return (
   
      <Flex h="100vh" bg="gray.100">
        {/* Sidebar */}
   
<AdminSidebar />
        {/* Content Area */}
        <Box flex="1" p={4}>
          {/* Header */}
          <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
            <IconButton
              icon={<FiMenu />}
              aria-label="Open menu"
              display={{ base: 'block', md: 'none' }}
              onClick={onOpen}
            />
            <Text fontSize="xl" fontWeight="bold">
              Admin Panel
            </Text>
          <button className='btn ' onClick={handleLogout}>Logout</button>
          </Flex>

        </Box>
      </Flex>
  
  );
}

export default Dashboard;
